var app = angular.module('debut', [], function($interpolateProvider) {
  $interpolateProvider.startSymbol('[[');
  $interpolateProvider.endSymbol(']]');
});

app.controller('searchCtrl', function($scope,$http){
  $scope.searchKeypress = function(e, val){
    if(val != ''){
      $http.get('/search?view=json&q='+val+'*').then(function (response) {
        console.log(response.data);
        $scope.results = response.data;
      });
    }
  }
});